import { push } from 'connected-react-router/immutable';
import _ from 'lodash';
import { initialize } from 'redux-form/immutable';
import { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs';

import { showMessageAction, showErrorAction } from 'containers/Notification/actions';
import BudgetApi from 'entities/budget/api';
import BudgetAllocationsApi from 'entities/budgetAllocation/api';
import DonationsApi from 'entities/donation/api';

import {
  FORM_IDENTIFIER,
  initSuccessAction,
  initFailedAction,
  submitSuccess,
  submitFailed,
  INIT,
  SUBMIT,
  InitAction,
  SubmitAction,
} from './types';

export const CorporateDonationInitialState = {
  amount: null,
  nonprofits: [],
  designation: null,
  note: null,
  budgetAllocation: null,
  donationTotalForValidator: null,
  isAnonymous: false,
};

const init = (action$: ActionsObservable<InitAction>) =>
  action$
    .ofType(INIT)
    .mergeMap(() => {
      const actions = [BudgetApi.fetchAll(), BudgetAllocationsApi.fetchAll()];

      return Observable.combineLatest(actions).mergeMap((resultingActions) => [
        ..._.flatten(resultingActions),
        initialize(FORM_IDENTIFIER, CorporateDonationInitialState, false),
        initSuccessAction(),
      ]);
    })
    .catch((e) => [
      initFailedAction(e),
      showErrorAction('Corporate donation form failed to initialize'),
    ]);

const submit = (action$: ActionsObservable<SubmitAction>) =>
  action$.ofType(SUBMIT).mergeMap(({ data }) => {
    const nonprofits = data.get('nonprofits').toArray();
    const currency = data.get('currencyCode') || nonprofits[0].get('currencyCode');

    return DonationsApi.logCorporateDonation({
      ...data.toJSON(),
      coverFee: true,
      amount: Number(data.get('amount')),
      currency,
      donationProvider: data.get('donationProvider'),
      donationPaymentMethod: 'CorporateBudget',
      nonprofits: nonprofits.map(
        (nonprofit) => nonprofit.get('nonprofitId') || nonprofit.get('id')
      ),
      isAnonymous: !!data.get('isAnonymous'),
    })
      .mergeMap((resultingAction) => [
        resultingAction,
        submitSuccess(data),
        showMessageAction('Corporate donation accepted'),
        push(`/donations/${resultingAction?.donation.id}`),
      ])
      .catch((error) => [submitFailed(error), showErrorAction('Corporate donation failed')]);
  });

export default [init, submit];
